import { CollectorDTO, UpdateUtilityBillDTO, CreateBillInDocumentDTO } from "api";
import { UtilityBillFormData } from "types";
import { isNullOrUndefined, safeParseNumber } from "utils";
import { compareCollector } from "pages/authenticated/documents/utils";
import { extractValue } from "./form-data";

export const getUtilityBillUpdateDTO = (
  utilityBillId: string,
  formData: UtilityBillFormData,
  collectors?: CollectorDTO[],
): UpdateUtilityBillDTO => {
  const formattedStartDate = formData.startDate?.isValid()
    ? formData.startDate.format("YYYY-MM-DDT00:00:00[Z]")
    : null;

  const formattedEndDate = formData.endDate?.isValid()
    ? formData.endDate.format("YYYY-MM-DDT00:00:00[Z]")
    : null;

  const measuredUnit = extractValue(formData?.measuredUnit);

  const measuredValue = safeParseNumber(formData.measuredValue, {
    decimalSeparator: true,
  });

  const amount = safeParseNumber(formData.amount, { decimalSeparator: true });

  const traveledMiles = safeParseNumber(formData.traveledMiles);

  return {
    id: utilityBillId,
    collectorId:
      collectors?.find((c) => compareCollector(formData?.collector, c))?.id ||
      null,
    startDate: formattedStartDate,
    endDate: formattedEndDate,
    measuredUnit,
    measuredValue,
    meterNumber: formData?.meterNumber,
    accountNumber: formData?.accountNumber,
    utilityTypeName: formData?.utilityTypeName,
    amount,
    currency: formData?.currency,
    subtype: formData?.subtype === "" ? null : formData?.subtype,
    traveledMiles,
  };
};

export const getCreateBillInDocumentDTO = (
  formData: UtilityBillFormData,
  collectors?: CollectorDTO[],
): CreateBillInDocumentDTO => ({
  collectorId:
    collectors?.find((c) => compareCollector(formData.collector, c))?.id ||
    null,
  endDate: formData.endDate?.format("YYYY-MM-DDT00:00:00[Z]") || null,
  startDate: formData.startDate?.format("YYYY-MM-DDT00:00:00[Z]") || null,
  measuredUnit: extractValue(formData.measuredUnit),
  measuredValue: safeParseNumber(formData.measuredValue) ?? 0,
  amount: safeParseNumber(formData.amount, { defaultValue: 0 }) ?? 0,
  currency: formData.currency,
  subtype:
    isNullOrUndefined(formData.subtype) || formData.subtype === ""
      ? null
      : formData.subtype,
  milesTraveled: safeParseNumber(formData.traveledMiles),
});

